export const conversion_rate_data = [
  { recruiter: "Lalaine", conversion_rate: 24 },
  { recruiter: "Liz Danielle", conversion_rate: 20 },
  { recruiter: "Maricar", conversion_rate: 25.71 },
  { recruiter: "Mayet", conversion_rate: 21 },
  { recruiter: "Monique", conversion_rate: 38 },
  { recruiter: "Nilham", conversion_rate: 36 },
  { recruiter: "Paolo", conversion_rate: 38 },
  { recruiter: "Princess Lei", conversion_rate: 0 },
  { recruiter: "Rosheil", conversion_rate: 10.25 },
  { recruiter: "Rogelio Jr.", conversion_rate: 36 },
  { recruiter: "Tobe", conversion_rate: 21.43 },
];